import React from "react";
import MetaTags from "react-meta-tags";
import NasHeader from "../../layouts/_nas/NasHeader";
import NasFooter from "../../layouts/_nas/NasFooter";
import Breadcrumbs from "../../layouts/Breadcrumbs";
import { useTranslation } from "react-i18next";

const NasSacramentRegistration = () => {
  const { t } = useTranslation();
  return (
    <>
      <MetaTags>
        <title>Holy Spirit Church | {t("_sacrament_registration")}</title>
        <meta name="description" content="#" />
      </MetaTags>
      <NasHeader />
      <Breadcrumbs breadcrumb={{ pagename: t("_sacrament_registration") }} />
      <NasFooter />
    </>
  );
};

export default NasSacramentRegistration;
